import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export default function CTASection({
  eyebrow = "Let's collaborate",
  title = "Ready to power your next campaign?",
  description = "Tell us about your brand, audience and goals. Our team will craft an influencer marketing plan tailored to your objectives.",
  ctaText = "Get in touch",
  ctaTo = "/contact",
  testId = "cta-section",
}) {
  return (
    <section data-testid={testId} className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-3xl border border-[#222] bg-gradient-to-br from-[#111] to-[#070707] p-10 md:p-16"
        >
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-[#FF4A00] opacity-20 rounded-full blur-[120px]" />
          <div className="absolute -bottom-32 -left-20 w-80 h-80 bg-[#CCFF00] opacity-10 rounded-full blur-[120px]" />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-8">
              <div className="label-eyebrow mb-5">{eyebrow}</div>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tighter text-[#F3E8E0] leading-[0.95] max-w-3xl">
                {title}
              </h2>
              <p className="mt-6 text-lg text-[#A3A3A3] max-w-2xl">{description}</p>
            </div>
            <div className="lg:col-span-4 flex lg:justify-end">
              <Link
                to={ctaTo}
                data-testid={`${testId}-cta`}
                className="inline-flex items-center gap-2 bg-[#FF4A00] text-white text-base font-medium px-7 py-4 rounded-full hover:bg-[#E64300] transition-all active:scale-95 group"
              >
                {ctaText}
                <ArrowUpRight className="w-5 h-5 group-hover:rotate-45 transition-transform" />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
